import React, { useState, useCallback, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useIntl } from "react-intl";

import Notification from "../../components/notification";
import { getEntity } from "../../modules/crudOperations";
import LoadError from "../../components/app/generic/loadError";
import LoadSkeleton from "../../components/app/generic/loadSkeleton";

function NotificationDetail() {
  const intl = useIntl();
  const { notificationId } = useParams();

  const history = useHistory();
  const handleClick = useCallback(() => {
    history.goBack();
  }, [history]);

  const [loading, setLoading] = useState();
  const [notification, setNotification] = useState();
  const loadNotification = useCallback(() => {
    setLoading(true);
    notificationId
      ? getEntity("notification", notificationId, setLoading, setNotification)
      : setLoading();
  }, [notificationId]);

  useEffect(() => {
    loadNotification();
  }, [loadNotification]);

  return loading ? (
    <LoadSkeleton />
  ) : notification === "e" ? (
    <LoadError
      buttonText={intl.formatMessage({
        id: "messages.back",
        defaultMessage: "Zpět",
      })}
      onClick={handleClick}
      message={intl.formatMessage({
        id: "notification.unknown",
        defaultMessage: "Neznámá notifikace!",
      })}
    />
  ) : (
    <Notification notification={notification} />
  );
}

export default NotificationDetail;
